<!-- 创建商家券模板并售卖商家券给商户接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/comUpwardStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "couponCode": "123456",
                "parkCode": "2KKN6111"
            },
            responseCode: {
                "data": {"couponCode":"180806100120885442","couponName":"金额抵扣10.00元券","couponType":1,"faceValue":10.00},
                "message": "ok",
                "resultCode": 0,
                "status": 1
            },
            infoData: {
                explain: "智慧停车开放平台调用第三方接口根据优惠券编码获取优惠券详细信息",
                urlPattern: this.commonUrls.third+"thirdCouponGetByCouponCode",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "第三方提供接口, 智慧停车开放平台主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponCode', info2: '是', info3: 'String', info4: '第三方优惠券编码' },
                        { info1: 'parkCode', info2: '否', info3: 'Integer', info4: '车场编码' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                            { info1: 'couponCode', info2: '是', info3: 'String', info4: '第三方券编号' },
                            { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠券名称' },
                            { info1: 'couponType', info2: '是', info3: 'int', info4: '优惠类型，0：免费券，车费0元结算；1：金额扣减券，车费减免固定金额结算；2：金额折扣券，车费折扣减免结算；3：金额固定值券，车费按券的固定值结算' },
                            { info1: 'faceValue', info2: '是', info3: 'String', info4: '面值，免费券:默认0，金额扣减券:为大于0的正数且保留2位小数，金额折扣券:为0-1且保留2位小数，金额固定券:为大于0的正数且保留2位小数，时间券:为大于0的整数，说明:金额相关的券都以元为单位，时间券以分为单位' },
                            { info1: 'validFrom', info2: '是', info3: 'String', info4: '有效开始时间yyyy-MM-dd HH:mm:ss' },
                            { info1: 'validTo', info2: '是', info3: 'String', info4: '有效结束时间yyyy-MM-dd HH:mm:ss' },
                            { info1: 'useVerify', info2: '否', info3: 'int', info4: '使用前是否需要校验 0否，1是；默认1'},
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/thirdCoupon/thirdCouponGetByCouponCode.vue